module.exports = __webpack_public_path__ + "static/media/sonali.831f7825.jpg";